// Game Schedule (the Quiz): constants shared by the page, the Schedule Game popup, the participants popup
// and the approval panels. Backend contract: docs/TRIVIA_GAME_INITIAL_PLAN.md section 9.2.

// The permissions.js key of the page — canAccessNav / canFeature are keyed by route.
export const GAME_SCHEDULE_ROUTE = '/game-schedule';
export const GAME_SCHEDULE_EDIT_FEATURE = 'game-schedule-edit';

// Games that use schedules. v1 has one (the Quiz), so the game select is a filter over the space's games
// rather than a flag on the game: Penalty and any other game is hidden from this page.
export const SCHEDULED_GAME_CODES = ['QUIZ'];

export const isScheduledGame = (game) => SCHEDULED_GAME_CODES.includes(String(game?.gameCode ?? '').toUpperCase());

// Period types, as the API names them (lowercase).
export const SCHEDULE_TYPES = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'custom', label: 'Custom' },
];
export const SCHEDULE_TYPE_LABEL = Object.fromEntries(SCHEDULE_TYPES.map((t) => [t.value, t.label]));

// Build defaults and limits (plan 9.2.4): a new quiz starts with 5 questions of 2 options each (the minimum;
// marketing adds more); nothing caps them, the minimum is what makes a question answerable.
export const DEFAULT_QUESTION_COUNT = 5;
export const DEFAULT_OPTION_COUNT = 2;
export const MIN_OPTIONS = 2;
export const NAME_MAX_LENGTH = 200;

// What a custom period defaults to: the next free Friday through the following Thursday (a quiz week).
export const FRIDAY = 5;
export const DEFAULT_CUSTOM_PERIOD_DAYS = 7;

// Phase chip of a quiz (the API sends upcoming / live / ended; "live" reads as Running on the page).
export const PHASES = {
  upcoming: { label: 'Upcoming', bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' },
  live:     { label: 'Running',  bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0' },
  ended:    { label: 'Ended',    bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' },
};

// Popup modes. The same popup serves all of them; `mode` decides the final button and what is editable.
export const MODAL_MODES = {
  CREATE:   'create',    // new draft
  EDIT:     'edit',      // direct edit of a draft
  PROPOSE:  'propose',   // edit of a live quiz that has not started: becomes an edit proposal
  RESUBMIT: 'resubmit',  // edit of a rejected proposal, sent again
  VIEW:     'view',      // read-only
};

export const PARTICIPANT_PAGE_SIZES = [10, 25, 50];
export const PARTICIPANT_DEFAULT_PAGE_SIZE = 25;
export const PARTICIPANT_SEARCH_MAX_LENGTH = 100;
